import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalService {

  private _currentPortal = new BehaviorSubject<string | null>(null);
  readonly currentPortal$: Observable<string | null> = this._currentPortal.asObservable();

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      // Use the router's state to find the primary activated route
      map(() => this.router.routerState.root),
      // Get the first child of the root route (which is often the main layout route)
      map(route => {
        let currentRoute = route;
        // Traverse down the route tree until we find the deepest primary outlet route
        while (currentRoute.firstChild && currentRoute.firstChild.outlet === 'primary') {
          currentRoute = currentRoute.firstChild;
        }
        return currentRoute;
      }),
      // Extract the 'portal' data, checking the current route and its parents
      map(route => {
        let portalValue: string | null = null;
        let current = route;
        // Traverse up the route tree to find 'portal' data
        while (current) {
          if (current.snapshot.data && current.snapshot.data['portal']) {
            portalValue = current.snapshot.data['portal'];
            break; 
          }
          current = current.parent!;
        }
        return portalValue;
      }),
      filter(portal => portal !== null) // Only emit if portal value  found
    ).subscribe(portal => {
      this._currentPortal.next(portal);
    });
  }

  isMentorPortal(): boolean {
    return this._currentPortal.getValue() === 'mentor';
  }

  isStudentPortal(): boolean {
    return this._currentPortal.getValue() === 'student';
  }

  getCurrentPortal(): string | null {
    return this._currentPortal.getValue();
  }
}